export default "__VITE_ASSET__$K7qXKF4__"